var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicationLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.356,
    height: 46.378,
    viewBox: "0 0 50.356 46.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2061",
    "data-name": "Trac\\xE9 2061",
    d: "M27.178,49.378l-3.651-3.336C10.561,34.239,2,26.454,2,16.9A13.74,13.74,0,0,1,15.848,3a15.054,15.054,0,0,1,11.33,5.282A15.054,15.054,0,0,1,38.508,3,13.74,13.74,0,0,1,52.356,16.9c0,9.554-8.561,17.338-21.527,29.166Z",
    transform: "translate(-2 -3)",
    fill: "#3fce97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicationLike);
export default __webpack_public_path__ + "static/media/indicationLike.8bd913bcc8ee5c5d079f68f2aa43cfbe.svg";
export { ForwardRef as ReactComponent };